import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

function MusteriEkle() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sube = queryParams.get('sube') || 'Bilinmeyen Şube';
  const [isim, setIsim] = useState('');
  const [soyisim, setSoyisim] = useState('');
  const [tcKimlikNo, setTcKimlikNo] = useState('');
  const [iletisimNo, setIletisimNo] = useState('+90 ');
  const [adres, setAdres] = useState('');
  const [bilgiler, setBilgiler] = useState('');
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [errors, setErrors] = useState({});

  // İsim ve soyisim kombinasyonunu Firebase belge ID'si için uygun formata dönüştürme
  const normalizeString = (str) => {
    return str
      ? str
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '')
      : '';
  };

  const formatUpperName = (value) => {
    const upper = (value || '').toLocaleUpperCase('tr-TR');
    return upper.replace(/[^A-ZÇĞİÖŞÜ\s]/g, '').replace(/\s{2,}/g, ' ');
  };

  const formatPhoneNumber = (value) => {
    // Her zaman +90 ile başlar, devamında sadece rakamlar tutulur.
    const raw = (value || '').replace(/[^\d]/g, '');
    let local = raw;
    if (local.startsWith('90')) {
      local = local.slice(2);
    }
    local = local.slice(0, 10);

    const p1 = local.slice(0, 3);
    const p2 = local.slice(3, 6);
    const p3 = local.slice(6, 8);
    const p4 = local.slice(8, 10);

    let formatted = '+90';
    if (p1) formatted += ` ${p1}`;
    if (p2) formatted += ` ${p2}`;
    if (p3) formatted += ` ${p3}`;
    if (p4) formatted += ` ${p4}`;
    if (!p1) formatted += ' ';
    return formatted;
  };

  const validateForm = async () => {
    const newErrors = {};
    if (!isim) newErrors.isim = 'İsim zorunlu';
    if (!soyisim) newErrors.soyisim = 'Soyisim zorunlu';
    if (tcKimlikNo && !/^\d{11}$/.test(tcKimlikNo)) newErrors.tcKimlikNo = 'TC Kimlik No 11 haneli olmalı';
    if (iletisimNo && iletisimNo.trim() !== '+90' && !/^\+90\s\d{3}\s\d{3}\s\d{2}\s\d{2}$/.test(iletisimNo)) {
      newErrors.iletisimNo = 'Telefon formatı +90 5xx xxx xx xx olmalı';
    }

    // İsim ve soyisim kombinasyonunun benzersizliğini kontrol et
    const normalizedMusteriId = normalizeString(`${isim} ${soyisim}`);
    if (normalizedMusteriId) {
      const musteriRef = doc(db, 'subeler', sube, 'musteriler', normalizedMusteriId);
      const musteriSnap = await getDoc(musteriRef);
      if (musteriSnap.exists()) {
        newErrors.isim = 'Bu isim ve soyisim zaten kayıtlı';
      }
    } else {
      newErrors.isim = 'Geçerli bir isim ve soyisim girin';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHata('');
    setBasari('');
    if (!(await validateForm())) {
      setHata('Lütfen tüm zorunlu alanları doğru doldurun.');
      return;
    }

    try {
      const normalizedMusteriId = normalizeString(`${isim} ${soyisim}`);
      const musteriRef = doc(db, 'subeler', sube, 'musteriler', normalizedMusteriId);
      await setDoc(musteriRef, {
        isim,
        soyisim,
        tcKimlikNo: tcKimlikNo || null,
        iletisimNo: iletisimNo || null,
        adres: adres || null,
        bilgiler: bilgiler || null,
        timestamp: new Date(),
        sube
      });
      setBasari('Müşteri başarıyla eklendi.');
      setHata('');
      setIsim('');
      setSoyisim('');
      setTcKimlikNo('');
      setIletisimNo('+90 ');
      setAdres('');
      setBilgiler('');
      setErrors({});
    } catch (err) {
      setHata(`Müşteri eklenemedi: ${err.message}`);
      setBasari('');
      console.error('Firestore Hatası:', err);
    }
  };

  const labelStyle = {
    fontSize: '16px',
    color: '#1f2937',
    width: '170px',
    fontWeight: 700
  };

  const inputBaseStyle = {
    width: '100%',
    height: '42px',
    padding: '10px 12px',
    fontSize: '15px',
    borderRadius: '8px',
    border: '1px solid #cfd8e3',
    outline: 'none',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    transition: 'border-color .2s, box-shadow .2s'
  };

  return (
    <div
      className="musteri-ekle-page"
      style={{
      background: 'linear-gradient(180deg, #f6f9ff 0%, #eef3fb 100%)',
      borderRadius: '14px',
      padding: '18px',
      boxShadow: '0 8px 20px rgba(15, 23, 42, 0.08)',
      border: '1px solid #d7e0ec',
      width: '860px',
      minHeight: '620px',
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      overflowY: 'auto',
      fontFamily: "'Helvetica Neue', sans-serif",
      position: 'relative'
    }}
    >
      <div className="musteri-ekle-header" style={{ borderBottom: '1px solid #e2e8f0', marginBottom: '14px', paddingBottom: '10px' }}>
        <h2 className="musteri-ekle-title" style={{ margin: 0, fontSize: '28px', color: '#102a43', letterSpacing: '0.2px' }}>Müşteri Ekle</h2>
        <p className="musteri-ekle-subtitle" style={{ margin: '4px 0 0', color: '#64748b', fontSize: '14px' }}>Müşteri bilgilerini eksiksiz girerek güvenli şekilde kayıt oluşturun.</p>
      </div>

      <form className="musteri-ekle-form" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px', background: '#ffffff', border: '1px solid #dde5f0', borderRadius: '12px', padding: '14px' }}>
        <div className="musteri-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="musteri-ekle-label" style={labelStyle}>İsim *</label>
          <div className="musteri-ekle-field" style={{ flex: 1, maxWidth: '500px' }}>
            <input
              type="text"
              value={isim}
              onChange={(e) => setIsim(formatUpperName(e.target.value))}
              placeholder="İsim"
              style={{ ...inputBaseStyle, border: errors.isim ? '1px solid #e63946' : inputBaseStyle.border }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = errors.isim ? '#e63946' : '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
            {errors.isim && <p style={{ color: '#e63946', fontSize: '13px', marginTop: '4px' }}>{errors.isim}</p>}
          </div>
        </div>

        <div className="musteri-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="musteri-ekle-label" style={labelStyle}>Soy İsim *</label>
          <div className="musteri-ekle-field" style={{ flex: 1, maxWidth: '500px' }}>
            <input
              type="text"
              value={soyisim}
              onChange={(e) => setSoyisim(formatUpperName(e.target.value))}
              placeholder="Soy İsim"
              style={{ ...inputBaseStyle, border: errors.soyisim ? '1px solid #e63946' : inputBaseStyle.border }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = errors.soyisim ? '#e63946' : '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
            {errors.soyisim && <p style={{ color: '#e63946', fontSize: '13px', marginTop: '4px' }}>{errors.soyisim}</p>}
          </div>
        </div>

        <div className="musteri-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="musteri-ekle-label" style={labelStyle}>TC Kimlik No</label>
          <div className="musteri-ekle-field" style={{ flex: 1, maxWidth: '500px' }}>
            <input
              type="text"
              value={tcKimlikNo}
              onChange={(e) => setTcKimlikNo((e.target.value || '').replace(/\D/g, '').slice(0, 11))}
              placeholder="TC Kimlik No"
              style={{ ...inputBaseStyle, border: errors.tcKimlikNo ? '1px solid #e63946' : inputBaseStyle.border }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = errors.tcKimlikNo ? '#e63946' : '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
            {errors.tcKimlikNo && <p style={{ color: '#e63946', fontSize: '13px', marginTop: '4px' }}>{errors.tcKimlikNo}</p>}
          </div>
        </div>

        <div className="musteri-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="musteri-ekle-label" style={labelStyle}>İletişim Numarası</label>
          <div className="musteri-ekle-field" style={{ flex: 1, maxWidth: '500px' }}>
            <input
              type="text"
              value={iletisimNo}
              onChange={(e) => setIletisimNo(formatPhoneNumber(e.target.value))}
              placeholder="+90 5xx xxx xx xx"
              style={{ ...inputBaseStyle, border: errors.iletisimNo ? '1px solid #e63946' : inputBaseStyle.border }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = errors.iletisimNo ? '#e63946' : '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
            {errors.iletisimNo && <p style={{ color: '#e63946', fontSize: '13px', marginTop: '4px' }}>{errors.iletisimNo}</p>}
          </div>
        </div>

        <div className="musteri-ekle-row" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label className="musteri-ekle-label" style={labelStyle}>Adres</label>
          <div className="musteri-ekle-field" style={{ flex: 1, maxWidth: '500px' }}>
            <input
              type="text"
              value={adres}
              onChange={(e) => setAdres(e.target.value)}
              placeholder="Adres"
              style={inputBaseStyle}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
          </div>
        </div>

        <div className="musteri-ekle-row musteri-ekle-row-textarea" style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <label className="musteri-ekle-label" style={labelStyle}>Müşteri Bilgileri</label>
          <div className="musteri-ekle-field" style={{ flex: 1, maxWidth: '500px' }}>
            <textarea
              value={bilgiler}
              onChange={(e) => setBilgiler(e.target.value)}
              placeholder="Müşteri Bilgileri"
              rows="3"
              style={{ ...inputBaseStyle, minHeight: '78px', resize: 'none', height: 'auto' }}
              onFocus={(e) => { e.target.style.borderColor = '#b47a2a'; e.target.style.boxShadow = '0 0 0 3px rgba(180, 122, 42, 0.15)'; }}
              onBlur={(e) => { e.target.style.borderColor = '#cfd8e3'; e.target.style.boxShadow = 'none'; }}
            />
          </div>
        </div>

        <button
          type="submit"
          className="musteri-ekle-submit"
          style={{
            padding: '11px',
            fontSize: '17px',
            fontWeight: 700,
            borderRadius: '8px',
            border: '1px solid #955d18',
            background: 'linear-gradient(135deg, #c98a30 0%, #a8671d 100%)',
            color: '#fff',
            cursor: 'pointer',
            transition: 'all 0.2s',
            marginTop: '8px',
            letterSpacing: '0.3px'
          }}
          onMouseEnter={(e) => {
            if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
              e.target.style.filter = 'brightness(1.05)';
            }
          }}
          onMouseLeave={(e) => {
            if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
              e.target.style.filter = 'brightness(1)';
            }
          }}
        >
          Müşteri Ekle
        </button>

        {hata && (
          <p style={{
            fontSize: '14px',
            color: '#b91c1c',
            backgroundColor: '#fee2e2',
            border: '1px solid #fecaca',
            padding: '9px',
            borderRadius: '8px',
            marginTop: '4px',
            textAlign: 'center'
          }}>
            {hata}
          </p>
        )}
        {basari && (
          <p style={{
            fontSize: '14px',
            color: '#166534',
            backgroundColor: '#dcfce7',
            border: '1px solid #bbf7d0',
            padding: '9px',
            borderRadius: '8px',
            marginTop: '4px',
            textAlign: 'center'
          }}>
            {basari}
          </p>
        )}
      </form>

      <style>{`
        /* --- MOBİL: Müşteri Ekle (masaüstü inline stillere dokunulmaz) --- */
        @media (max-width: 480px) {
          .musteri-ekle-page {
            width: 100% !important;
            max-width: 100% !important;
            min-height: auto !important;
            padding: 12px !important;
            border-radius: 12px !important;
            box-sizing: border-box !important;
          }

          .musteri-ekle-title {
            font-size: 22px !important;
          }

          .musteri-ekle-subtitle {
            font-size: 13px !important;
            line-height: 1.45 !important;
          }

          .musteri-ekle-form {
            padding: 12px !important;
            gap: 12px !important;
          }

          .musteri-ekle-row {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 6px !important;
          }

          .musteri-ekle-row-textarea {
            align-items: stretch !important;
          }

          .musteri-ekle-label {
            width: 100% !important;
            font-size: 14px !important;
          }

          .musteri-ekle-field {
            max-width: none !important;
            width: 100% !important;
          }

          .musteri-ekle-page input,
          .musteri-ekle-page textarea {
            font-size: 16px !important;
          }

          .musteri-ekle-submit {
            width: auto !important;
            min-width: 200px !important;
            justify-self: center !important;
            align-self: center !important;
            font-size: 16px !important;
            padding: 12px 22px !important;
            touch-action: manipulation;
            -webkit-tap-highlight-color: transparent;
          }
        }
      `}</style>
    </div>
  );
}

export default MusteriEkle;